<template>
  <span class="ui-label">
    <span
      class="text"
      :class="{ 'font-weight-bold': textBold }"
      :style="{ color: customStyle.textColor }"
    >
      <slot>
        <span v-html="text" />
      </slot>
    </span>

    <ui-tooltip-icon
      v-if="helpTooltip"
      class="ml-4 ml-first-0"
      preset="help"
      :text="helpTooltip"
    />
    <ui-plan-limits
      v-if="showPlanLimitsIcon"
      class="ml-4 ui-plan-limits-icon"
    />
  </span>
</template>

<script setup lang="ts">
import { usePlanLimits } from '@/composables';

const props = withDefaults(
  defineProps<{
    textBold?: boolean;
    customStyle?: { textColor?: string };
    text?: string;
    helpTooltip?: string;
    planLimits?: import('@/composables').PlanLimitsProp;
    planLimitsEditable?: boolean;
  }>(),
  {
    textBold: true,
    customStyle: () => ({}),
    planLimitsEditable: false,
  }
);

const { showPlanLimitsIcon } = usePlanLimits(
  () => props.planLimits,
  () => props.planLimitsEditable
);
</script>

<style lang="scss" scoped>
.ui-label {
  .text {
    font-size: 13px;
    line-height: 1;
  }
}

.ui-plan-limits-icon{
  position:relative;
  top:2px;
}
</style>
